import { defineComponent, ref, computed, onMounted, onBeforeUnmount, openBlock, createElementBlock, unref, normalizeStyle, withKeys, withModifiers, renderSlot, createVNode, createCommentVNode } from "vue";
import { V as VaButton } from "../va-button/index.js";
import { i as isServer } from "../../utils/ssr.js";
import { w as warn } from "../../utils/console.js";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { u as useNumericProp } from "../../composables/useNumericProp.js";
import { u as useTranslation } from "../../composables/useTranslation.js";
const _hoisted_1 = ["aria-label", "onKeydown"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaBacktop"
  },
  __name: "VaBacktop",
  props: {
    ...useComponentPresetProp,
    target: {
      type: [Object, String],
      default: void 0
    },
    visibilityHeight: { type: [Number, String], default: 300 },
    speed: { type: [Number, String], default: 50 },
    verticalOffset: { type: String, default: "1rem" },
    horizontalOffset: { type: String, default: "1rem" },
    color: { type: String, default: "" },
    horizontalPosition: {
      type: String,
      default: "right",
      validator: (value) => ["right", "left"].includes(value)
    },
    verticalPosition: {
      type: String,
      default: "bottom",
      validator: (value) => ["bottom", "top"].includes(value)
    },
    ariaLabel: { type: String, default: "$t:backToTop" }
  },
  setup(__props) {
    const props = __props;
    const targetScrollValue = ref(0);
    const computedStyle = computed(() => ({
      [props.verticalPosition]: props.verticalOffset,
      [props.horizontalPosition]: props.horizontalOffset
    }));
    let targetElement;
    const visibilityHeightComputed = useNumericProp("visibilityHeight");
    const speedComputed = useNumericProp("speed");
    const getTargetElement = () => {
      if (!props.target) {
        return window;
      }
      if (typeof props.target === "string") {
        const target = document.querySelector(props.target);
        if (!target) {
          warn(`Target element [${props.target}] is not found, falling back to window.`);
          return window;
        }
        return target;
      }
      return props.target;
    };
    const scrolled = ref(false);
    const interval = ref(0);
    const scrollToTop = () => {
      if (scrolled.value) {
        return;
      }
      scrolled.value = true;
      if (targetElement instanceof Window) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        return;
      }
      interval.value = window.setInterval(() => {
        if (targetElement instanceof Element) {
          if (targetElement.scrollTop === 0) {
            clearInterval(interval.value);
            scrolled.value = false;
          } else {
            const next = Math.floor(targetElement.scrollTop - speedComputed.value);
            targetElement.scrollTo(0, next);
          }
        }
      }, 15);
    };
    const handleScroll = () => {
      targetScrollValue.value = targetElement instanceof Window ? targetElement.scrollY : targetElement.scrollTop;
    };
    const server = isServer();
    const visible = computed(() => {
      if (server) {
        return false;
      }
      return targetScrollValue.value > visibilityHeightComputed.value;
    });
    if (!server) {
      onMounted(() => {
        targetElement = getTargetElement();
        targetElement.addEventListener("scroll", handleScroll, true);
      });
      onBeforeUnmount(() => targetElement == null ? void 0 : targetElement.removeEventListener("scroll", handleScroll));
    }
    const { tp, t } = useTranslation();
    return (_ctx, _cache) => {
      return visible.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "va-backtop",
        role: "button",
        "aria-label": unref(tp)(_ctx.$props.ariaLabel),
        tabindex: "1",
        style: normalizeStyle(computedStyle.value),
        onClick: scrollToTop,
        onKeydown: withKeys(withModifiers(scrollToTop, ["stop"]), ["enter"])
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createVNode(unref(VaButton), {
            "aria-hidden": "true",
            icon: "va-arrow-up",
            color: __props.color
          }, null, 8, ["color"])
        ])
      ], 44, _hoisted_1)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaBacktop.css';
//# sourceMappingURL=VaBacktop.vue_vue_type_script_setup_true_lang.js.map
